<template>
    <div class="workOrder-box">
        <HeaderNav
            header-title="发货单"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="warpper">
            <div v-if="currentCar">
                <template v-if="currentCar.is_lock">
                    <!-- 超时 -->
                    <div class="current-order present" :class="{'isLock':currentCar.is_lock}">
                        <div class="title">
                            {{ lockTime }}前，您的订单被其他车辆替换
                        </div>
                        <div class="content">
                            <div class="top">
                                <img src="./../../../assets/images/home_sj/timeout_bg.png">
                                <div class="info">
                                    请单击【确定】<br>
                                    将重新开始排队等待派单！
                                </div>
                            </div>
                            <div class="bottom" @click="unlockCar">
                                <span class="btn">确定</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <!-- 任务完成到场 -->
                    <div class="current-order present" v-if="currentCar.status===1 || currentCar.status===2">
                        <div class="title">
                            车辆已进场排队，等待派单中
                        </div>
                        <div class="content">
                            <div class="top">
                                <div class="order-num">
                                    <span class="iconfont icontongzhi"></span>
                                    <span>您当前排在第<span class="red">{{ currentIndex }}</span>位，预计<span class="red">{{ waitTime }}</span>分钟后派单！</span>
                                </div>
                                <div class="car-info">
                                    <div class="car">
                                        <div>
                                            <img src="./../../../assets/images/home_sj/workOrderTanker1.png">
                                        </div>
                                        <div class="num">
                                            {{ currentCar.plate_number }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom" @click="toDriverQueue">
                                <span class="btn">查看详情</span>
                            </div>
                        </div>
                    </div>
                    <!-- 返厂途中 暂无任务 -->
                    <div class="current-order no-order" v-else-if="currentCar.status===8">
                        <div class="title">
                            暂无任务，请返场等待派单
                        </div>
                        <div class="content">
                            <div class="top">
                                <img src="./../../../assets/images/home_sj/workOrderbgNo.png">
                                <div class="driver-num">
                                    {{ currentCar.plate_number }}
                                </div>
                            </div>
                            <div class="bottom">
                            </div>
                        </div>
                    </div>
                    <template v-if="currentOrder">
                        <!-- 有任务 待接单 -->
                        <template v-if="[3,4,5,21,31].includes(currentCar.status)">
                            <div
                                class="current-order not-order"
                                :class="{'isFrozen':isFrozen||currentOrder.pcb_status===7}"
                            >
                                <template v-if="isFrozen||currentOrder.pcb_status===7">
                                    <div class="title">
                                        您的订单已被冻结，请联系调度
                                    </div>
                                    <div class="content">
                                        <div class="top">
                                            <img src="./../../../assets/images/home_sj/frozen_bg.png">
                                        </div>
                                        <div class="bottom">
                                            <div class="info-lable">
                                                <span class="iconfont iconshijian"></span>
                                                <span>订单冻结时间</span>
                                            </div>
                                            <div class="info-time">
                                                {{ currentOrder.frozen_time }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="title">
                                        <template v-if="currentCar.status===4||currentCar.status===5||currentCar.status===31">
                                            打料中等待出场
                                        </template>
                                        <template v-else>
                                            请前往{{ currentOrder.line_name }}生产线{{ currentCar.status===3?'扫码打料':'打料' }}
                                        </template>
                                        <i class="iconfont iconerweima1" @click="openQRCode(currentOrder)"></i>
                                    </div>
                                    <div class="content">
                                        <div class="top" v-for="(item,index) in currentOrderList" :key="'keyC'+index">
                                            <div
                                                class="materialPlan-item"
                                            >
                                                <i
                                                    class="corner-marker"
                                                    v-if="currentCar.status===3||currentCar.status===4||currentCar.status===5"
                                                >已接单</i>
                                                <i class="corner-marker" v-else>未接单</i>
                                                <ul>
                                                    <li class="tit">
                                                        <span class="pre-icon materialPlan01"></span>
                                                        <span class="info">运输单号:{{ item.pcb_number }}</span>
                                                    </li>
                                                    <li>
                                                        <van-row>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan02"></span>
                                                                <span class="info">强度等级:{{ item.strength_grade_name|encryption }}</span>
                                                            </van-col>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan07"></span>
                                                                <span class="info">出场时间:{{ item.out_time|toStar }}</span>
                                                            </van-col>
                                                        </van-row>
                                                    </li>
                                                    <li>
                                                        <van-row>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan03"></span>
                                                                <span class="info">方量:{{ item.volume|encryption }}m³</span>
                                                            </van-col>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan04"></span>
                                                                <span class="info">浇筑方式：{{ item.pouring_name|encryption }}</span>
                                                            </van-col>
                                                        </van-row>
                                                    </li>
                                                    <li>
                                                        <van-row>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan08"></span>
                                                                <span class="info">工程名称:{{ item.project_name|encryption }}</span>
                                                            </van-col>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan09"></span>
                                                                <span class="info">工程位置:{{ item.project_address|encryption }}</span>
                                                            </van-col>
                                                        </van-row>
                                                    </li>
                                                    <li>
                                                        <van-row>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan05"></span>
                                                                <span class="info">联系人:{{ item.xclxr|toStar }}</span>
                                                            </van-col>
                                                            <van-col span="12">
                                                                <span class="pre-icon materialPlan06"></span>
                                                                <span class="info">联系电话:{{ item.xclxr_phone|toStar }}</span>
                                                            </van-col>
                                                        </van-row>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="bottom">
                                            <template v-if="currentCar.status===3">
                                                <span class="btn" @click="scanPcbNumber(currentOrder)">扫码</span>
                                                <span class="btn" @click="punchImage">拍照</span>
                                            </template>
                                            <template v-else-if="currentCar.status===4||currentCar.status===5||currentCar.status===31">
                                                <span
                                                    class="btn btn-frozen"
                                                >等待出场</span>
                                                <span class="btn" @click="punchImage">拍照</span>
                                            </template>
                                            <span class="btn" v-else @click="receiptPcbNumber">接单</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template
                            v-else-if="[6,7,31,73,77].includes(currentCar.status)"
                        >
                            <div :class="['current-order',item.is_check?'':'disable']" v-for="(item,index) in currentOrderList" :key="'keyA'+index">
                                <div
                                    class="title"
                                    v-if="item.car_status===6"
                                >
                                    运输中，请注意安全！
                                    <i class="iconfont iconerweima1" @click="openQRCode(item)"></i>
                                </div>
                                <div class="title" v-else-if="item.car_status===7">
                                    请尽快完成卸料
                                    <i class="iconfont iconerweima1" @click="openQRCode(item)"></i>
                                </div>
                                <div class="title" v-else-if="item.car_status===73">
                                    请务必点击结束卸料！
                                    <i class="iconfont iconerweima1" @click="openQRCode(item)"></i>
                                </div>
                                <div class="title" v-else-if="item.car_status===77">
                                    请如实对该客户进行评价！
                                    <i class="iconfont iconerweima1" @click="openQRCode(item)"></i>
                                </div>
                                <div class="content">
                                    <div class="top">
                                        <div
                                            class="materialPlan-item"
                                        >
                                            <i class="corner-marker corner-marker-arrive" v-if="item.car_status===7">已到达</i>
                                            <i class="corner-marker corner-marker-discharge" v-else-if="item.car_status===73">开始卸料</i>
                                            <i class="corner-marker corner-marker-overdischarge" v-else-if="item.car_status===77">结束卸料</i>
                                            <ul v-if="item.car_status===3">
                                                <li class="tit">
                                                    <span class="pre-icon materialPlan01"></span>
                                                    <span class="info">运输单号:{{ item.pcb_number }}</span>
                                                </li>
                                                <li>
                                                    <van-row>
                                                        <van-col span="10">
                                                            <span class="pre-icon materialPlan02"></span>
                                                            <span class="info">强度等级:{{ item.strength_grade_name|encryption }}</span>
                                                        </van-col>
                                                        <van-col span="14">
                                                            <span class="pre-icon materialPlan03"></span>
                                                            <span class="info">方量:{{ item.volume|encryption }}m³</span>
                                                        </van-col>
                                                    </van-row>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan04"></span>
                                                    <span class="info">浇筑方式：{{ item.pouring_name|encryption }}</span>
                                                </li>
                                                <li>
                                                    <van-row>
                                                        <van-col span="10">
                                                            <span class="pre-icon materialPlan05"></span>
                                                            <span class="info">联系人:{{ item.xclxr|toStar }}</span>
                                                        </van-col>
                                                        <van-col span="14">
                                                            <span class="pre-icon materialPlan06"></span>
                                                            <span class="info">联系电话:{{ item.xclxr_phone|toStar }}</span>
                                                        </van-col>
                                                    </van-row>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan07"></span>
                                                    <span class="info" v-if="item.car_status===3">出场时间:{{ item.out_time|toStar }}</span>
                                                    <span class="info" v-else>出场时间:{{ item.out_time|toStar }}</span>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan08"></span>
                                                    <span class="info">工程名称:{{ item.project_name|encryption }}</span>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan09"></span>
                                                    <span
                                                        class="info"
                                                        :class="{'info-short':[4,5,6,7,31,73].includes(item.car_status)}"
                                                    >
                                                        工程位置:{{ item.project_address|encryption }}
                                                    </span>
                                                </li>
                                            </ul>
                                            <ul v-else>
                                                <li class="tit">
                                                    <span class="pre-icon materialPlan01"></span>
                                                    <span class="info">运输单号:{{ item.pcb_number }}</span>
                                                </li>
                                                <li>
                                                    <van-row>
                                                        <van-col span="10">
                                                            <span class="pre-icon materialPlan02"></span>
                                                            <span class="info">强度等级:{{ item.strength_grade_name }}</span>
                                                        </van-col>
                                                        <van-col span="14">
                                                            <span class="pre-icon materialPlan03"></span>
                                                            <span class="info">方量:{{ item.volume }}m³</span>
                                                        </van-col>
                                                    </van-row>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan04"></span>
                                                    <span class="info">浇筑方式：{{ item.pouring_name }}</span>
                                                </li>
                                                <li>
                                                    <van-row>
                                                        <van-col span="10">
                                                            <span class="pre-icon materialPlan05"></span>
                                                            <span class="info">联系人:{{ item.xclxr }}</span>
                                                        </van-col>
                                                        <van-col span="14">
                                                            <span class="pre-icon materialPlan06"></span>
                                                            <span
                                                                class="info"
                                                                @click="showActionSheet(item)"
                                                            >联系电话:<span class="phone">{{ item.xclxr_phone }}</span></span>
                                                        </van-col>
                                                    </van-row>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan07"></span>
                                                    <span class="info" v-if="item.car_status===3">出场时间:{{ item.out_time|toStar }}</span>
                                                    <span class="info" v-else>出场时间:{{ item.out_time }}</span>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan08"></span>
                                                    <span class="info">工程名称:{{ item.project_name }}</span>
                                                </li>
                                                <li>
                                                    <span class="pre-icon materialPlan09"></span>
                                                    <span
                                                        class="info"
                                                        :class="{'info-short':[4,5,6,7,31,73].includes(item.car_status)}"
                                                    >
                                                        工程位置:{{ item.project_address }}
                                                    </span>
                                                </li>
                                            </ul>
                                            <div
                                                class="navigation-btn"
                                                v-if="item.car_status===6"
                                                @click.stop="navigationFn"
                                            >
                                                <span class="iconfont iconsend"></span>
                                                <span>导航</span>
                                            </div>
                                            <!-- <div
                                                class="navigation-btn"
                                                v-if="currentCar.status===7||currentCar.status===73"
                                            >
                                                <span class="iconfont iconxiangji"></span>
                                                <span>拍照</span>
                                            </div> -->
                                            <van-uploader
                                                class="navigation-btn"
                                                :after-read="afterRead"
                                                multiple
                                                capture="camera"
                                                @click-upload="clickUpload(item)"
                                                :readonly="useCustomUpload"
                                                v-if="item.car_status===7||item.car_status===73"
                                            >
                                                <span class="iconfont iconxiangji"></span>
                                                <span>拍照</span>
                                            </van-uploader>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <span
                                            class="btn"
                                            v-if="item.car_status===6"
                                            @click="driverArrive(item)"
                                        >已到达</span>
                                        <template v-else-if="item.car_status===7">
                                            <span class="btn" @click="scanPcbNumber(item)">扫码泵车</span>
                                            <span
                                                class="btn btn-start-discharge"
                                                @click="startDischarge(item)"
                                            >开始卸料</span>
                                        </template>
                                        <span
                                            class="btn btn-over-discharge"
                                            v-else-if="item.car_status===73"
                                            @click="showUnload(item)"
                                        >结束卸料</span>
                                        <span
                                            class="btn btn-delivery-evaluation"
                                            v-else-if="item.car_status===77"
                                            @click="toEvaluate(item, 'new')"
                                        >交付评价</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
            >
                <div
                    class="materialPlan-item"
                    v-for="(item) in historyOrder"
                    :key="item.pcb_number"
                    @click="toElectronicTicket(item)"
                >
                    <i class="corner-marker" v-if="item.driver_eva" @click.stop="toEvaluate(item, 'over')">已评价</i>
                    <i class="corner-marker" v-else>未评价</i>
                    <div class="handle-btns">
                        <!-- <span class="evaluate-btn surplus-btn" @click.stop="surplus(item)" v-if="item.is_surplus===0">剩退灰</span> -->
                        <span class="evaluate-btn" @click.stop="toEvaluate(item, 'new')" v-if="!item.driver_eva">交付评价</span>
                    </div>
                    <ul>
                        <li class="tit">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">运输单号:{{ item.pcb_number }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="10">
                                    <span class="pre-icon materialPlan02"></span>
                                    <span class="info">强度等级:{{ item.strength_grade_name }}</span>
                                </van-col>
                                <van-col span="14">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">方量:{{ item.volume }}m³</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan04"></span>
                            <span class="info">浇筑方式：{{ item.pouring_name }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="10">
                                    <span class="pre-icon materialPlan05"></span>
                                    <span class="info">联系人:{{ item.xclxr }}</span>
                                </van-col>
                                <van-col span="14">
                                    <span class="pre-icon materialPlan06"></span>
                                    <span class="info">联系电话:{{ item.xclxr_phone }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan07"></span>
                            <span class="info">出场时间:{{ item.out_time }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan08"></span>
                            <span class="info">工程名称:{{ item.project_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan09"></span>
                            <span class="info">工程位置:{{ item.project_address }}</span>
                        </li>
                    </ul>
                </div>
            </van-list>
            <div class="no-data" v-if="!currentOrder&&historyOrder.length===0&&!currentCar"></div>
        </div>
        <van-action-sheet
            v-model="actionSheetShow"
            cancel-text="取消"
            class="workorder-sheet"
        >
            <h5>{{ currentOrder.xclxr }}</h5>
            <a @click="callPhone(currentOrder.xclxr_phone)">联系电话：{{ currentOrder.xclxr_phone }}</a>
        </van-action-sheet>
        <van-dialog
            v-model="showBeforeUnload"
            title="填写卸料信息"
            :show-confirm-button="false"
            :show-cancel-button="false"
        >
            <van-form>
                <van-field
                    class="unload-input input1"
                    v-model="unload_volume"
                    name="卸料方量"
                    label="卸料方量"
                    placeholder="请输入卸料方量"
                    type="number"
                    :rules="[{ required: true, pattern: '\d*', message: '请输入卸料方量' }]"
                    error-message=""
                >
                    <template #right-icon>
                        方
                    </template>
                </van-field>
                <van-field
                    class="unload-input input1"
                    v-model="sign_volume"
                    name="签收方量"
                    label="签收方量"
                    type="number"
                    placeholder="请输入签收方量"
                    :rules="[{ required: true, pattern: '\d*', message: '请输入卸料方量' }]"
                >
                    <template #right-icon>
                        方
                    </template>
                </van-field>
                <van-field class="unload-input input1" name="switch" label="是否剩退">
                    <template #input>
                        <van-switch v-model="switchChecked" size="20"></van-switch>
                    </template>
                </van-field>
                <van-field
                    class="unload-input"
                    v-model="pouring_name"
                    name="浇筑方式"
                    label="浇筑方式"
                    placeholder="请输入签收方量"
                    @click="showPouring=true"
                    :rules="[{ required: true, pattern: '\d*', message: '请输入卸料方量' }]"
                    readonly
                >
                    <template #right-icon>
                        <i class="iconfont">&#xe640;</i>
                    </template>
                </van-field>
                <van-field
                    class="unload-input"
                    v-model="pump_plate_number_mark"
                    name="泵车号"
                    label="泵车号"
                    placeholder="选择或填写泵车号"
                    :rules="[{ required: true, pattern: '\d*', message: '请选择或填写泵车号' }]"
                >
                    <template #right-icon>
                        <i class="iconfont" @click="showPumpPlateNumberSelect">&#xe640;</i>
                    </template>
                </van-field>
                <van-field
                    class="unload-input"
                    v-model="pumping_volume"
                    name="泵送方量"
                    label="泵送方量"
                    type="number"
                    placeholder="填写泵送方量"
                    :rules="[{ required: true, pattern: '\d*', message: '请输入泵送方量' }]"
                    :readonly="!['302-JZ0-02','302-JZ0-03','302-JZ0-04'].includes(pouring)"
                >
                    <template #right-icon>
                        方
                    </template>
                </van-field>
                <div class="dialog-btns">
                    <span class="cancel-btn" @click="handleDialogCancel">取消</span>
                    <span class="sure-btn" @click="handleDialogSure">确认</span>
                </div>
            </van-form>
        </van-dialog>
        <!-- 选择浇筑方式-->
        <van-action-sheet v-model="showPouring" :actions="actionsPouring" @select="onSelectPouring"></van-action-sheet>
        <!-- 选择泵车号-->
        <van-action-sheet v-model="showPumpPlateNumber" :actions="actionsPumpPlateNumber" @select="onSelectPumpPlateNumber"></van-action-sheet>
        <van-popup
            v-model="qRCodeShow"
            closeable
            class="qRCodePopup"
        >
            <img :src="qRCodeSrc">
        </van-popup>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
import utils from '@/utils/util';
import { eventBus } from '@/common/eventBus.ts';
export default {
    components: {
        HeaderNav,
    },
    filters: {
        encryption() {
            const str = '*****';
            return str;
        },
    },
    data() {
        return {
            status: 3,
            MobilePhone: '',
            pagetion: {
                pageindex: 1,
                pagesize: 3,
            },
            currentOrderList: [], // 所有任务单
            currentOrder: {}, // 当前操作的任务单
            historyOrder: [], // 历史任务单
            currentIndex: 0, // 当前排队次序
            waitTime: 0, // 等待时间
            loading: false,
            finished: false,
            num: 0,
            isFrozen: false, // 是否冻结
            isLock: false, // 是否超时
            currentCar: {}, // 当前车辆信息
            lockTime: 0, // 锁定时间
            driverUploadData: { // 司机上传数据
                driver_files: '',
                pcb_number: '',
                task_number: '',
            },
            startUpload: false, // 上传完成标识
            oldFiles: '',
            fileLength: 0,
            uploadNums: 0,
            showBeforeUnload: false, // 结束卸料前填写卸料方量
            unload_volume: '', // 卸料方量
            sign_volume: '', // 签收方量
            pouring: '', // 浇筑方式
            pouring_name: '', // 浇筑方式
            pump_plate_number_mark: '', // 泵车代号
            pumping_volume: '', // 泵送方量
            switchChecked: false, // 是否剩退
            actionSheetShow: false, // 拨打电话面板
            showPouring: false, // 浇筑方式面板
            actionsPouring: [], // 浇筑方式 数组
            showPumpPlateNumber: false, // 泵车号面板
            actionsPumpPlateNumber: [], // 泵车号 数组
            // 二维码弹出层状态
            qRCodeShow: false,
            // 二维码图片地址
            qRCodeSrc: '',

            // 是否使用自定义上传  ios不用自定义 一直为false
            useCustomUpload: false,
            aliyunOssToken: '',
            buCode: 'ProductionAffix',
        };
    },
    methods: {
        // 页面滚动到底部加载下一步
        onLoad() {
            setTimeout(() => {
                this.pagetion.pageindex += 1;
                this.getDriverPage();
            }, 200);
        },
        // 获取分页数据
        getDriverPage() {
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios
                .get('/interfaceApi/production/productpcb/driver_page_multiple?phone='
                + this.MobilePhone + '&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize + '&type=1')
                .then(res => {
                    if (res) {
                        this.loading = false;
                        if (this.pagetion.pageindex === 1) {
                            this.currentOrderList = res.first;
                            if (res.first.length > 0) {
                                this.currentOrder = res.first[0] || {};
                                if (this.currentCar.status === 1 || this.currentCar.status === 2) {
                                    this.getDriverQueue();
                                }
                                this.getDriverEvaluate();
                            }
                        }
                        if (res.page.total) {
                            res.page.rows.map(item => {
                                const arr = this.historyOrder.filter(v => item.pcb_number === v.pcb_number);
                                if (arr.length < 1) {
                                    this.historyOrder.push(item);
                                }
                            });
                            // this.historyOrder = this.historyOrder.concat(res.page.rows);
                            if (Number(this.historyOrder.length) >= res.page.total) {
                                this.finished = true;
                            }
                            if (Number(this.historyOrder.length) === 0) {
                                this.finished = true;
                            }
                        } else {
                            this.finished = true;
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 重新加载页面数据
        reloadFn() {
            this.pagetion.pageindex = 1;
            this.historyOrder = [];
            this.getVehicleDriver();
            setTimeout(() => {
                this.getDriverPage();
            }, 0);
        },
        // 获取所用车辆信息
        getVehicleDriver() {
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios.get('/interfaceApi/production/vehicleinfo/get_vehicle_driver?phone=' + this.MobilePhone)
                .then(res => {
                    if (res) {
                        this.currentCar = res;
                        localStorage.setItem('currentOrderStatus', res.status);
                        if (res.is_lock) {
                            this.parseLockTime(res.lock_time);
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },

        // 获取司机相关排车列表
        getDriverQueue() {
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios
                .get('/interfaceApi/production/vehicleinfo/get_driver_queue?phone=' + this.MobilePhone)
                .then(res => {
                    if (res) {
                        res.map((item, index) => {
                            if (item.driver_phone === this.MobilePhone) {
                                this.currentIndex = index + 1;
                                this.waitTime = index * 12;
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 司机接单
        receiptPcbNumber() {
            const pcb_numbers = this.currentOrderList.map(item => item.pcb_number);
            this.$axios
                .put('/interfaceApi/production/productpcb/receipt_multiple?receiptType=0', pcb_numbers)
                .then(res => {
                    // Toast.success('接单成功');
                    if (res) {
                        Dialog({ message: res });
                    }
                    this.reloadFn();
                    localStorage.setItem('currentOrderStatus', 3);
                })
                .catch(error => {
                    // this.$toast(error.ErrorCode.Message);
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 扫码
        scanPcbNumber(item) {
            this.currentOrder = item;
            this.$toast('扫码功能正在开发中...');
            // this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },
        // 扫码调用原生后的回调
        jyCallback_DriveScanFinished(sandata) {
            const dataParse = JSON.parse(sandata);
            if (this.currentCar.status === 3) {
                this.$axios
                    .get('/interfaceApi/production/vehicleinfo/scan/' + this.currentOrder.pcb_number + '/' + dataParse.lineCode)
                    .then(res => {
                        if (res) {
                            Toast.success('扫码成功');
                            this.reloadFn();
                            localStorage.setItem('currentOrderStatus', 31);
                        }
                    })
                    .catch(error => {
                        this.$toast(error.ErrorCode.Message);
                    });
                return;
            }
            // 卸料扫码
            if (this.currentCar.status === 7) {
                this.$dialog.confirm({
                    message: dataParse.carNumber,
                })
                    .then(() => {
                        // 确认提交
                        this.$axios
                            .post('/interfaceApi/production/productpcb/modify_site_pump_truck'
                                + `?pcb_number=${this.currentOrder.pcb_number}&car_number=${dataParse.carNumber}`)
                            .then(() => {
                                this.$toast.success('保存成功');
                            })
                            .catch(error => {
                                this.$toast(error.ErrorCode.Message);
                            });
                    });
            }
        },
        // 已到达
        driverArrive(item) {
            this.currentOrder = item;
            // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            //     this.handleDriverArrive();
            // } else {
            //     this.$callMobile('JYExternalNative', 'jyDriverUntieVehicleEvent');
            // }
            this.handleDriverArrive(null, item);
        },
        jyCallback_DriverUntieVehicle(data) {
            const dataParse = JSON.parse(data);
            this.handleDriverArrive(dataParse);
        },
        async handleDriverArrive(data, item) {
            if (!this.currentOrder.pcb_number) {
                this.$toast('发货单异常,请返回首页重新进入司机接单页面');
                return;
            }
            const arriveFun = queryStr => {
                return this.$axios.get('/interfaceApi/production/vehicleinfo/arrive/' + queryStr);
            };
            try {
                // 手动点击 已到达
                if (item) {
                    let queryStr = this.currentOrder.plate_number + '/'
                        + this.currentOrder.mixstation_code + '/' + this.currentOrder.pcb_number;
                    if (data) {
                        queryStr += '?longitude=' + data.longitude + '&latitude=' + data.latitude;
                    }
                    await arriveFun(queryStr);
                } else {
                    // 自动已到达
                    const pms = [];
                    this.currentOrderList.forEach(order => {
                        let queryStr = order.plate_number + '/' + order.mixstation_code + '/' + order.pcb_number;
                        if (data) {
                            queryStr += '?longitude=' + data.longitude + '&latitude=' + data.latitude;
                        }
                        pms.push(arriveFun(queryStr));
                    });
                    await Promise.all(pms);
                }
                Toast.success('已到达');
                this.reloadFn();
                localStorage.setItem('currentOrderStatus', 7);
            } catch (e) {
                if (e.ErrorCode) {
                    this.$toast(e.ErrorCode.Message);
                }
            }
        },
        // 开始卸料
        startDischarge(item) {
            this.currentOrder = item;
            if (!this.currentOrder.pcb_number) {
                this.$toast('发货单异常,请返回首页重新进入司机接单页面');
                return;
            }
            this.$axios
                .get('/interfaceApi/production/vehicleinfo/unload/'
                + this.currentOrder.plate_number + '/' + this.currentOrder.mixstation_code + '/' + this.currentOrder.pcb_number)
                .then(res => {
                    if (res) {
                        Toast.success('开始卸料');
                        this.reloadFn();
                        localStorage.setItem('currentOrderStatus', 73);
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 弹出卸料信息
        showUnload(item) {
            this.currentOrder = item;
            this.unloadOverData();
            this.showBeforeUnload = true;
            this.unload_volume = this.currentOrder.volume;
            this.sign_volume = this.currentOrder.volume;
        },
        // 结束卸料
        handleDialogSure() {
            // if (action === 'cancel') {
            //     done();
            //     this.switchChecked = false;
            //     return;
            // }
            if (!this.currentOrder.pcb_number) {
                this.$toast('发货单异常,请返回首页重新进入司机接单页面');
                return;
            }
            let isSurplus = 2;
            this.switchChecked ? isSurplus = 1 : isSurplus = 2;
            if (this.unload_volume && this.sign_volume) {
                this.$axios
                    .post('/interfaceApi/production/vehicleinfo/unload_over', {
                        plate_number: this.currentOrder.plate_number,
                        mixstation_code: this.currentOrder.mixstation_code,
                        pcb_number: this.currentOrder.pcb_number,
                        unload_volume: this.unload_volume,
                        sign_volume: this.sign_volume,
                        pouring: this.pouring,
                        pouring_name: this.pouring_name,
                        pump_plate_number_mark: this.pump_plate_number_mark,
                        pumping_volume: this.pumping_volume,
                    })
                    .then(res => {
                        if (res) {
                            Toast.success('卸料完成');
                            this.surplus(this.currentOrder, isSurplus);
                            this.showBeforeUnload = false;
                            this.reloadFn();
                            localStorage.setItem('currentOrderStatus', 77);
                        }
                    })
                    .catch(error => {
                        this.$toast(error.ErrorCode.Message);
                    });
            } else {
                // this.$toast('请填写卸料方量或签收方量!');
            }
        },
        handleDialogCancel() {
            this.showBeforeUnload = false;
            this.switchChecked = false;
        },
        // 评价
        toEvaluate(data, type) {
            this.$router.isBack = 2;
            if (type === 'new') {
                this.$router.push({ name: 'newTransSheet', params: { pcb_number: data.pcb_number } });
            } else {
                this.$router.push({ name: 'transSheetInfo', params: { pcb_number: data.pcb_number } });
            }
            // this.$router.push({ name: 'newTransSheet', params: { pcb_number: data.pcb_number, type: type } });
        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },
        // 导航
        navigationFn() {
            this.$toast('导航功能正在开发中...');
            // if (this.currentOrder) {
            //     const json = {
            //         carNumber: this.currentOrder.pcb_number,
            //         endName: this.currentOrder.project_address,
            //         endLongitude: this.currentOrder.project_longitude,
            //         endLatitude: this.currentOrder.project_latitude,
            //     };
            //     this.$callMobile('JYExternalNative', 'jyDriveStartNavigationClick', json);
            // } else {
            //     eventBus.$emit('driverPcb');
            // }

        },
        // 导航回调
        jyCallback_DriveEndNavigation(data) {
            // 点击【已到达】按钮参数传：1；
            // 点击【退出】按钮参数传2。
            if (data === '1') {
                this.driverArrive();
            }
        },
        // 跳转到排队界面
        toDriverQueue() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'vehicleQueue' });
        },
        // 车辆解锁
        unlockCar() {
            this.$axios
                .put('/interfaceApi/production/vehicleinfo/unlock/' + this.currentCar.driver_phone + '/' + this.currentCar.plate_number)
                .then(res => {
                    if (res) {
                        Toast.success('解锁完成');
                        this.reloadFn();
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 锁定时间处理
        parseLockTime(lockTime) {
            const new_date = new Date();
            const old_date = new Date(lockTime);
            const difftime = (new_date - old_date) / 1000; // 计算时间差,并把毫秒转换成秒
            let days = 0;
            let hours = 0;
            let minutes = 0;
            // eslint-disable-next-line radix
            days = parseInt(difftime / 86400); // 天  24*60*60*1000
            // eslint-disable-next-line radix
            hours = parseInt(difftime / 3600) - 24 * days; // 小时 60*60 总小时数-过去的小时数=现在的小时数
            // eslint-disable-next-line radix
            minutes = parseInt(difftime % 3600 / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
            if (days > 0) {
                this.lockTime = days + '天';
            } else if (days === 0 && hours > 0) {
                this.lockTime = hours + '小时';
            } else if (days === 0 && hours === 0 && minutes > 0) {
                this.lockTime = minutes + '分钟';
            } else {
                this.lockTime = '1分钟';
            }
        },
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            setTimeout(() => {
                this.uploadFile(file);
            }, 500);
            this.getDriverEvaluate();
        },
        // 自定义原生上传 安卓
        clickUpload(item) {
            this.currentOrder = item;
            // ios系统不调用
            if (!this.useCustomUpload) {
                return;
            }
            const callMobileData = {
                albumSelection: false,
            };
            this.$callMobile('JYExternalNative', 'PhotoUpload', callMobileData);
        },
        // 原生拍照回调
        callback_PhotoUpload(data) {
            const name = new Date().getTime().toString();
            const base64Data = 'data:image/jpg;base64,' + data;
            const file = utils.base64ToFile(base64Data, name);
            this.afterRead({ file: file });
        },
        // 上传附件
        uploadFile(file) {
            this.$toast.loading();
            this.driverUploadData.driver_files = '';
            this.startUpload = false;
            this.uploadNums = 0;
            if (Array.isArray(file)) {
                this.fileLength = file.length;
                this.recurFile(0, file);
            } else {
                this.fileLength = 1;
                this.upGroupFun(file);
            }

        },
        recurFile(j, file) {
            this.upGroupFun(file[j].file);
            const next = j + 1;
            if (next < file.length) {
                this.recurFile(next, file);
            }
        },
        // 上传附件请求
        uploadRequest(formData) {
            this.$axios
                .post(this.GLOBAL.FILE_BASE_URL + 'file/uploadfile', formData)
                .then(res => {
                    this.$toast.clear();
                    if (res) {
                        this.driverUploadData.driver_files += res[0] + ',';
                        this.uploadNums++;
                        if (this.uploadNums === this.fileLength) {
                            this.driverUpload();
                        }
                    }
                }).catch(err => {
                    this.$toast(err.Errorcode.Message);
                });
        },

        // 获取上传通行证
        getOssToken() {
            this.$axios.get(this.GLOBAL.FILE_BASE_URL_OSS + `credential/GetPostPolicy/${this.buCode}`).then(res => {
                if (res) {
                    this.aliyunOssToken = res;
                    // localStorage.setItem('aliyunOssToken', JSON.stringify(res));
                }
            });
        },
        // 上传组名
        upGroupFun(val) {
            const filename = val ? val.name : '现场照片';
            // 判断是否过期，过期重新调用获取通信证方法
            const formData = new FormData();
            // 注意formData里append添加的键的大小写
            formData.append('key', `${this.aliyunOssToken.dir}${this.currentOrder.pcb_number}/${filename}`); // 存储在oss的文件路径
            formData.append('OSSAccessKeyId', this.aliyunOssToken.accessid); // accessKeyId
            formData.append('policy', this.aliyunOssToken.policy); // policy
            formData.append('Signature', this.aliyunOssToken.signature); // 签名
            // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', val ? val : filename);
            // formData.append('FileDescription', this.newFile.FileDescription);
            formData.append('success_action_status', 200); // 成功后返回的操作码
            formData.append('Content-Type', 'multipart/form-data'); // 成功后返回的操作码

            // 回调参数
            const obj = {
                bucket: this.aliyunOssToken.bucket ? this.aliyunOssToken.bucket : this.buCode, // 存储桶名称
                business_type_code: this.buCode, // 业务类型编码
                object_name: `${this.aliyunOssToken.dir}${this.currentOrder.pcb_number}/${filename}`, // 文件对象名
                show_name: filename, // 显示文件名
                size: 0, // 文件大小
                mimeType: '',
                mime_type: val ? val.type : '',
                data_id: this.currentOrder.pcb_number, // 业务数据id
                directory_id: '', // 目录id
                tenant_id: this.$takeTokenParameters('TenantId'), // 租户id
                // FileDescription: this.newFile.FileDescription, // 文件描述
            };
            this.uploadFun(formData, obj);
        },
        // 上传文件
        uploadFun(formData, val) {
            this.$.ajax({
                url: this.aliyunOssToken.host,
                type: 'POST',
                data: formData,
                cache: false, // 不缓存数据
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: data => { // 成功回调
                    this.callBackFun(val);
                },
            });
        },
        // 上传的回调
        callBackFun(obj) {
            this.$axios.post(this.GLOBAL.FILE_BASE_URL_OSS + 'api/UploadCallback', obj).then(res => {
                if (res) {
                    this.driverUploadData.driver_files += res.id + ',';
                    this.driverUpload();
                }
            });
        },

        // 拉取司机评价
        getDriverEvaluate() {
            if (this.currentOrder) {
                this.$axios
                    .get('/interfaceApi/production/productpcb/get_driver_evaluate?pcb_number=' + this.currentOrder.pcb_number)
                    .then(res => {
                        if (res) {
                            if (res.driver_files) {
                                this.oldFiles = res.driver_files;
                            }
                        }
                    })
                    .catch(error => {
                        this.$toast(error.Errorcode.Message);
                    });
            }
        },
        // 司机上传资料
        driverUpload() {
            this.driverUploadData.pcb_number = this.currentOrder.pcb_number;
            this.driverUploadData.task_number = this.currentOrder.task_number;
            this.driverUploadData.driver_files += this.oldFiles;
            this.$axios
                .post('/interfaceApi/production/productpcb/driver_upload', this.driverUploadData)
                .then(res => {
                    if (res) {
                        Toast.success('拍照上传成功!');
                    }
                }).catch(err => {
                    this.$toast(err.Errorcode.Message);
                });
        },
        // 剩退灰
        surplus(data, isSurplus) {
            this.$axios
                .put('/interfaceApi/production/productpcb/surplus/' + data.pcb_number + '/' + isSurplus)
                .then(res => {
                    if (res) {
                        data.is_surplus = res;
                    }
                }).catch(err => {
                    this.$toast(err.Errorcode.Message);
                });
        },
        // 弹出拨打电话底部菜单
        showActionSheet(item) {
            this.currentOrder = item;
            if (this.currentOrder.xclxr_phone) {
                this.actionSheetShow = true;
            }
        },
        // 拨打电话
        callPhone(phone) {
            this.$callMobile('JYTeamsNative', 'jyMakePhoneCall', phone);
        },
        // 打开二维码
        async openQRCode(item) {
            this.currentOrder = item;
            // 打开二维码先验证 车辆状态 为3时(已完成) 禁止打开二维码
            const pcdInfo = await this.getPcdInfo();
            if (pcdInfo.status === 3) {
                this.$toast('该发货单已完成，二维码已失效');
                return;
            }
            this.qRCodeSrc = '/interfaceApi/auth/get_qrcode/'
                        + `+${this.currentOrder.pcb_number}+${this.currentOrder.pcb_number}+${this.currentOrder.pcb_number}+/7`;
            this.qRCodeShow = true;
        },
        // 获取排车单信息
        getPcdInfo() {
            return this.$axios.post('/interfaceApi/production/productpcb/get_pcb_info/' + this.currentOrder.pcb_number);
        },

        // 打料拍照
        punchImage() {
            const pcb_numbers = this.currentOrderList.map(item => item.pcb_number);
            this.$router.isBack = 2;
            this.$router.push({
                path: '/punchImageList', query: {
                    pcb_numbers: pcb_numbers,
                },
            });
        },
        // 获取卸料数据
        async unloadOverData() {
            const res = await this.$axios.get('/interfaceApi/production/vehicleinfo/unload_over_data?pcb_number=' + this.currentOrder.pcb_number);
            this.pouring = res.pouring;
            this.pouring_name = res.pouring_name;
            this.pump_plate_number_mark = res.pump_plate_number_mark;
            this.pumping_volume = this.currentOrder.volume;

            this.actionsPouring = res.pouringData.map(item => {
                item.name = item.pouring_name;
                return item;
            });
            this.actionsPumpPlateNumber = res.pump_plate_number_marks.map(item => {
                return {
                    pump_plate_number_mark: item,
                    name: item,
                };
            });

        },
        // 选择浇筑方式
        onSelectPouring(item) {
            this.pouring = item.pouring;
            this.pouring_name = item.pouring_name;
            if (!['302-JZ0-02', '302-JZ0-03', '302-JZ0-04'].includes(this.pouring)) {
                this.pumping_volume = 0;
            }
            this.showPouring = false;
        },
        // 选择泵车号
        showPumpPlateNumberSelect() {
            if (this.actionsPumpPlateNumber.length > 0) {
                this.showPumpPlateNumber = true;
            } else {
                this.$toast.fail('暂无泵车号选项');
            }
        },
        // 选择泵车号
        onSelectPumpPlateNumber(item) {
            this.pump_plate_number_mark = item.pump_plate_number_mark;
            this.showPumpPlateNumber = false;
        },
    },
    created() {
        // 如果不是苹果
        if (!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            // 如果当前 安卓集成了 自定义上传
            if (window.JYExternalNative?.PhotoUpload) {
                this.useCustomUpload = true;
                window.callback_PhotoUpload = this.callback_PhotoUpload;
            }
        }
    },
    mounted() {
        // 获取文件上传信息
        const aliy = localStorage.getItem('aliyunOssToken') ? JSON.parse(localStorage.getItem('aliyunOssToken')) : null;
        const date = new Date();
        if (aliy && aliy.expire && aliy.expire * 1000 > date.getTime()) {
            this.aliyunOssToken = aliy;
        } else {
            this.getOssToken();
        }
        // 转发原生回调函数
        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished;
        window.jyCallback_DriveEndNavigation = this.jyCallback_DriveEndNavigation;
        window.jyCallback_DriverUntieVehicle = this.jyCallback_DriverUntieVehicle;
        // 添加事件总线eventBus
        // 刷新排车列表
        eventBus.$on('driverPcb', () => {
            this.reloadFn();
        });
        // 跳转到导航界面
        eventBus.$on('toNavigation', () => {
            this.navigationFn();
        });
        // 冻结订单
        eventBus.$on('frozenOrder', data => {
            if (this.currentOrder.pcb_number === data.pcb_number) {
                if (Number(data.frozen) === 1) {
                    this.isFrozen = true;
                } else if (typeof data.frozen === 'undefined' || Number(data.frozen) === 0) {
                    this.isFrozen = false;
                }
            }
        });
        this.getVehicleDriver();
        this.getDriverPage();
    },
    beforeDestroy() {
        // 清除事件总线eventBus1
        eventBus.$off('driverPcb');
        eventBus.$off('toNavigation');
        eventBus.$off('frozenOrder');
    },
};
</script>

<style lang="stylus">
.workOrder-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .workorder-sheet
        h5,a
            font-size 16rpx
            line-height 45rpx
            text-align center
        h5
            color #333333
            background #F8F8F8
        a
            display block
            color #0189FC
            border-bottom 1px solid #F0F0F0
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            background #F0F0F0!important
    .unload-input
        height 45rpx
        &::after
            display none
        .van-field__label
            width 5.2rem;
            margin-right -10rpx
        input
            padding-left 5rpx
            width: 200rpx;
            height: 32rpx;
            background: #F8F8F8;
            border-radius: 2rpx;
            border: 1px solid #D0D0D0;
            color #333333
        .van-field__right-icon
            margin-left -30rpx
    .input1
        .van-cell__title
            color #00508D
        input
            background: #F2FBFF;
            border-radius: 2rpx;
            border: 1px solid #91D5FF;
            color #0091FF
        .van-field__right-icon
            margin-left -30rpx
            color #0091FF
    .dialog-btns
        height 48rpx
        border-top 1px solid #f8f9fa
        line-height 48rpx
        .cancel-btn
            display inline-block
            text-align center
            border-right 1px solid #f8f9fa
            width 50%
            box-sizing border-box
            cursor pointer
        .sure-btn
            width 50%
            text-align center
            color #218dfa
            display inline-block
            cursor pointer
    .warpper
        height 100%
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        padding 0 12rpx 12rpx 12rpx
        .materialPlan-item
            width 100%
            background #ffffff
            position relative
            overflow hidden
            padding 16rpx 16rpx 32rpx 16rpx
            color #666666
            font-size 14rpx
            .van-col
                white-space nowrap
                overflow hidden
            li
                overflow hidden
                margin-bottom 10rpx
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.materialPlan01
                        background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.materialPlan02
                        background-image url(./../../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan03
                        background-image url(./../../../assets/images/icons/icon_6.png)
                    &.materialPlan04
                        background-image url(./../../../assets/images/icons/icon_32.png)
                    &.materialPlan05
                        background-image url(./../../../assets/images/icons/icon_3.png)
                    &.materialPlan06
                        background-image url(./../../../assets/images/icons/icon_4.png)
                    &.materialPlan07
                        background-image url(./../../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan08
                        background-image url(./../../../assets/images/icons/icon_2.png)
                    &.materialPlan09
                        background-image url(./../../../assets/images/icons/icon_gy_2.png)
                    &.materialPlan20
                        background-image url(./../../../assets/images/icons/icon_18.png)
                .info
                    float left
                    width calc(100% - 26rpx)
                    &.info-short
                        width calc(100% - 86rpx)
                    .phone
                        color #5588f1
                        text-decoration underline
                &.tit
                    font-size 14rpx
                    font-weight 600
                    color #061F3E
                    .icondanjubianhao
                        font-size 18rpx
                        margin 3rpx 8rpx 0 0
                        float left
            .corner-marker
                position absolute
                right 0
                top 18rpx
                width: 60rpx;
                height: 25rpx;
                line-height 25rpx
                text-align center
                font-size 12rpx
                color #fff
                background: #FF6702;
                border-radius:20rpx 0px 0px 20rpx;
                &.corner-marker-arrive
                    background #0101B5
                &.corner-marker-discharge
                    background #5588F1
                &.corner-marker-overdischarge
                    background #979EA7
            .handle-btns
                position absolute
                bottom 10rpx
                right 10rpx
            .evaluate-btn
                float right
                line-height 26rpx
                border 1px solid #5588F1
                color #5588F1
                font-size 12rpx
                border-radius 5rpx
                padding 0 6rpx
            .surplus-btn
                margin-left 10rpx
                border 1px solid #fa8435
                color #fa8435
            .navigation-btn
                position absolute
                bottom 10rpx
                right 5rpx
                width 60rpx
                height 25rpx
                border-radius 4rpx
                color #D17830
                text-align center
                line-height 25rpx
                font-size 12rpx
                border: 1px solid #D17830;
                .iconsend
                    font-size 12rpx
                    margin-right 3rpx
                .iconxiangji
                    font-size 14rpx
                    margin-right 5rpx
                .van-uploader__input-wrapper
                    width 100%
        .van-list
            .materialPlan-item
                margin-bottom 10rpx
                .corner-marker
                    right 6rpx
        .current-order
            margin 15rpx 0
            &.disable
                opacity 0.45
                pointer-events none
            .title
                padding-left 20rpx
                height 40rpx
                line-height 40rpx
                text-align left
                font-size 18rpx
                background #2864CB
                color #fff
                position relative
                >i
                    width 28rpx
                    height 28rpx
                    position absolute
                    top 6rpx
                    right 6rpx
                    background #fff
                    &:before
                        font-size 28rpx
                        line-height 29rpx
                        color #2864CB
                        vertical-align top
            .content
                // height 307rpx
                background #fff
                background-size 100% 100%
                // padding 12rpx
                .top
                    // height 211rpx
                    // border-bottom 1px dashed #D7D7D7
                    padding 12rpx 0 22rpx 12rpx
                    position relative
                    .materialPlan-item
                        padding 0 5rpx
                        li
                            margin-bottom 8rpx
                        .corner-marker
                            top 2rpx
                    &:before
                        content ''
                        background url(./../../../assets/images/home_sj/workOrderbg1.png) no-repeat
                        width 100%
                        display inline-block
                        height 22rpx
                        background-size 100% 100%
                        position absolute
                        left 0
                        bottom 0
                .bottom
                    text-align center
                    display flex
                    justify-content space-around
                    .btn
                        width 160rpx
                        height 45rpx
                        background linear-gradient(0deg,rgba(4,186,128,1),rgba(3,223,153,1))
                        border-radius 4rpx
                        display inline-block
                        margin 5rpx 0 15rpx 0
                        font-size 22rpx
                        color #ffffff
                        text-align center
                        line-height 45rpx
                        font-family '微软雅黑'
                        font-weight bold
                        -webkit-text-stroke 1px #04BA80
                        text-stroke 1px #04BA80
                        &.btn-start-discharge
                            background:linear-gradient(0deg,rgba(250,134,55,1),rgba(250,193,95,1));
                            -webkit-text-stroke 1px #F0802C
                            text-stroke 1px #F0802C
                        &.btn-over-discharge
                            background linear-gradient(0deg,rgba(236,102,112,1),rgba(251,127,137,1))
                            -webkit-text-stroke 1px #DE5660
                            text-stroke 1px #DE5660
                        &.btn-delivery-evaluation
                            background linear-gradient(0deg,rgba(53,150,251,1),rgba(99,177,251,1))
                            -webkit-text-stroke 1px #348FE9
                            text-stroke 1px #348FE9
                        &.btn-frozen
                            background linear-gradient(0deg,rgba(175,184,193,1),rgba(219,226,232,1))
                            -webkit-text-stroke 1px #B0B9C2
                            text-stroke 1px #B0B9C2
            &.present
                .title
                    background #F8A032
                .content
                    padding 0
                    .top
                        // height 221rpx
                        border-bottom 0
                        padding 12rpx
                        .order-num
                            height 45rpx
                            text-align center
                            font-size 15rpx
                            padding 10rpx 0
                            .icontongzhi
                                color #D6010F
                                font-size 16rpx
                                margin-right 10rpx
                            .red
                                color #D6010F
                        .car-info
                            padding 12rpx 12rpx 20rpx 12rpx
                            .car
                                text-align center
                                img
                                    width 76rpx
                                    height 76rpx
                                .num
                                    font-size 18rpx
                                    margin-top 10rpx
                    .bottom
                        .btn
                            background linear-gradient(0deg,rgba(53,150,251,1),rgba(99,177,251,1))
                            -webkit-text-stroke 1px #3396FB
                            text-stroke 1px #3396FB
            &.no-order
                .title
                    background #979EA7
                .content
                    .top
                        position relative
                        img
                            width 345rpx
                            height 190rpx
                        .driver-num
                            position absolute
                            bottom 20rpx
                            left 0
                            text-align center
                            width 100%
                    .bottom
                        height 70rpx
            &.not-order
                .top
                    .corner-marker
                        background #FF6600
                .bottom
                    .btn
                        background: linear-gradient(180deg, #53B0FF 0%, #2978FF 100%);
                        -webkit-text-stroke 1px #3396FB
                        text-stroke 1px #3396FB
            &.isLock
                .title
                    background #E70200
                .content
                    // padding 12rpx
                    .top
                        position relative
                        // border-bottom 1px dashed #d7d7d7 !important
                        // height 211rpx
                        padding 12rpx 12rpx 22rpx 12rpx
                        img
                            width 100%
                            height 100%
                        .info
                            position absolute
                            bottom 25rpx
                            left 0
                            width 100%
                            text-align center
                            color #666666
            &.isFrozen
                .title
                    background #E70200
                .content
                    // padding 12rpx
                    .top
                        position relative
                        // border-bottom 1px dashed #d7d7d7 !important
                        // height 211rpx
                        padding 12rpx
                        img
                            width 100%
                    .bottom
                        padding-bottom 10rpx
                        .info-lable
                            display flex
                            align-items center
                            font-size 14rpx
                            color #979EA7
                            background #F6F6F6
                            margin 0 20rpx 10rpx 100rpx
                            padding 3px
                            white-space nowrap
                            .iconshijian
                                font-size 14rpx
                                margin-right 3rpx
                        .info-time
                            font-size 16rpx
    .qRCodePopup
        width 250rpx
        height 250rpx
        padding 20rpx
        overflow hidden
        .van-popup__close-icon--top-right
            top 10rpx
            right 10rpx
        img
            width 100%
            height 100%
</style>
<style>
.workOrder-box .van-list__error-text, .van-list__finished-text, .van-list__loading{
    position: relative;
    height: 50rpx;
}
.workOrder-box .van-loading__spinner{
    position: relative!important;
    top: 0!important;
    left: 0!important;
    display: inline-block;
    width: 30px;
    max-width: 100%;
    height: 30px;
}
</style>
